import styled, {keyframes} from 'styled-components';
import { rotateAnimation } from './Buttons.styles';
import palette from '../../utilities/palette';

export const Loader = styled.div`
  pointer-events: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: azure;
  animation: rotate 1s ease infinite;
  animation-name: ${rotateAnimation};
`;

export const StyledSelect = styled.select` 
    width: 40%;
    font-size: 18px;
    margin-top: 3px;
    min-width: 160px;
`;

export const TextEntry = styled.input`
    width: 40%;
    font-size: 20px;
    // margin-bottom: 10px;
    // margin-top: 10px;
    margin-top: 3px;
    min-width: 220px;
    border: 1px solid #dbdbdb;
`;

export const TextHint = styled.label`
    font-size: 16px; 
    margin-bottom: 10px;
    margin-top: 10px;
`;

export const TextHintHighlight = styled.label`
    font-size: 16px; 
    font-weight: bold;
`;

export const TextEntryLong = styled.input`
    width: 100%;
    font-size: 20px;
    margin-bottom: 10px;
    margin-top: 10px;
    border: 1px solid #dbdbdb;
`;

export const TextInput = styled.input.withConfig({
    shouldForwardProp: (prop) => !['isArchitectureTypeMatch', 'isPrefilledByCatalog', 'isDisableUnlocked', 'isError', 'stylingVariant'].includes(prop)
})<{
    isArchitectureTypeMatch?: boolean;
    isPrefilledByCatalog?: boolean;
    isDisableUnlocked?: boolean;
    isError?: boolean;
    variant?: 'header' | 'body' | 'error' | 'default';
}>` &&& {
        width: 550px;
        height: 38px;
        padding: 0 10px;
        font-size: 18px;
        border: 1px solid;
        border-radius: 4px;
        ${props => props.isError && `border: 1px solid ${palette.stepper.error};`}

        background-color: ${props => {
            if (props.variant === 'header') {
                return palette.header.main;
            }
            if (props.variant === 'body') {
                return 'white';
            }
            return 'white';
        }};

        border-color: ${props => {
            if (props.isError) {
                return palette.stepper.error;
            }
            if (props.variant === 'header') {
                return palette.header.main;
            }

            if (props.variant === 'body') {
                return "white"
            }

            return '#dbdbdb';
        }};
        
        &:hover {
            background-color: ${props => {
                if (props.variant === 'header') {
                    return 'white';
                }

                if (props.variant === "body") {
                    return "white"
                }
                return palette.header.main;
            }};
            border-color: ${props => {
                if (props.variant === 'header' || props.variant === "body") {
                    return palette.main;
                }
                return '#dbdbdb';
            }};
        }

        &::placeholder {
            color: ${palette.main};
        }
    }
`;



const mismatchedArchitectureStyle = {
  backgroundColor: palette.darkGrey,
  color: palette.darkGrey,
}
const prefilledStyle = {
  color: "rgb(153, 153, 153)",
  backgroundColor: "rgb(240, 240, 240)",
  // if hovered, revert to default color
}

export const SelectInput = styled.select.withConfig({
    shouldForwardProp: (prop) => !['isError'].includes(prop)
})<{
    isError?: boolean;
}>` &&& {
        width: 550px;
        height: 40px;
        padding: 0 10px;
        font-size: 18px;
        border: 1px solid #dbdbdb;
        ${props => props.isError && `border: 1px solid ${palette.stepper.error};`}
    }
`;


export const HeaderDiv = styled.div` &&& {
    padding: 5px;
}
`;

export const FlexColumnDiv = styled.div` &&& {
    display: flex;
    flex-direction: column;
}
`;

export const FlexRowDiv = styled.div` &&& {
    display: flex;
    flex-direction: row;
}
`;

        // borderLeft: `5px solid ${palette.main}`,
        // borderRadius: '5px',
        // paddingLeft: '20px',
        // display: 'flex',
        // flexDirection: 'row',
export const StepperContentHeaderDiv = styled.div` &&& {
    border-left: 5px solid ${palette.main};
    border-radius: 5px;
    padding-left: 20px;
    display: flex;
    flex-direction: row;
}
`;

export const StepperContentBodyDiv = styled.div` &&& {
    margin-top: 10px;
    background-color: ${palette.header.main};
    display: flex;
    flex-direction: row;
    padding: 20px;
    border-radius: 5px;
}`;

export const ItemForAccordion = styled.div`
    display: flex; 
    justify-content: space-between;
    align-items: center; 
    width: 100%;
`;

export const FormLayout = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  min-height: 100vh; /* allow body background gradient to show beyond initial viewport */
    fontFamily: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;

export const HeaderContainerDiv = styled.div`
    color: ${palette.main};
    background: transparent;
    display: flex;
    padding: 0 2vw;
    align-items: center;
    height: 15vh;
    font-size: 24px;
    font-weight: bold;
    width: 100%;
  position: relative; /* needed for fading bottom border pseudo-element */
  /* Fading bottom border */
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 5px; /* thickness of the fading border */
    background: linear-gradient(to right, rgba(0,0,0,0), grey 10%, grey 80%, rgba(0,0,0,0));
    opacity: 0.4;
    pointer-events: none;

  }
`;

export const FieldLabelRequired= styled.label` &&& {
    font-size: 18px; 
    &:after {
        content:" *";
        color: red;
    }
}
`;

export const WarningBannerDiv = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 2vw;
    background: #fff4e5;
    color: ${palette.stepper.warning};
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid ${palette.stepper.warning};
    box-sizing: border-box;
    position: sticky;
    top: 0;
    z-index: 1000;
`;

export const FieldLabel = styled.label <{
    variant?: 'header' | 'body' | 'error' | 'default';
}>`
    font-size: 18px;
    font-weight: 600;
    color: ${props => {
        if (props.variant === 'header') {
            return 'grey'
        }
        if (props.variant === 'body') {
            return palette.main;
        }
        if (props.variant === 'error') {
            return palette.stepper.error;
        }
        return 'black';
    }};
    
`

export const TextExample = styled.span`
    font-size: 14px; 
    color: ${palette.primary.exampleText}
`;

export const FormBorderStyle = styled.form`
    padding: 0 10px;
    margin: 0 10px;
    fontFamily: 'FordF-1-Regular';
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 85vh;
`;


export const _dropContainer = styled.label`
  position: relative;
  display: flex;
  gap: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  padding: 20px;
  border-radius: 10px;
  border: 2px dashed ${palette.primary.main};
  color: #444;
  cursor: pointer;
  transition: background 0.2s ease-in-out, border 0.2s ease-in-out;

  &:hover,
  &.drag-active {
    background: #eee;
    border-color: #111;
  }

  &:hover .drop-title,
  &.drag-active .drop-title {
    color: #222;
  }
`;

export const _dropTitle = styled.span`
  color: #444;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  transition: color 0.2s ease-in-out;
`;


export const SpanError = styled.span`
  color: ${palette.stepper.error};
  margin-left: 5px;
`;

// Define the fade animation keyframes
const fade = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

const Dot = styled.span.withConfig({
    shouldForwardProp: (prop) => !['size'].includes(prop)
})<{
    size?: string;
}>`
  display: inline-block;
  width: ${(props) => (props.size === 'small' ? '2.5px' : '5px')};
  height: ${props => (props.size === 'small' ? '2.5px' : '5px')};
  border-radius: 50%;  /* Makes the dot rounded */

  background-color: #42526E;
  margin-right: 5px;
  animation: ${fade} 1s infinite;
`;

const SecondDot = styled(Dot)`
  animation-delay: 0.3s;
`;

const ThirdDot = styled(Dot)`
  animation-delay: 0.6s;
`;

export const DotFlashing = ({size = 'small'}) => {
  return (
    <div>
      <Dot size={size}/>
      <SecondDot size={size} />
      <ThirdDot size={size} />
    </div>
  );
};


export const InputFile = styled.input.attrs({ type: 'file' })`
  width: 350px;
  max-width: 100%;
  color: #444;
  padding: 5px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #555;
`;


export const HintHighlightSpan = styled.span`
    color: ${palette.main};
    font-weight: bold;
    font-size: 16px;
`;

export const PrefillFileLabel = styled.label`
    color: grey;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
        color: ${palette.main};
    }
`;

export const DropContainer = styled.label<{
  isDragged?: boolean;
}>`
  position: relative;
  display: flex;
  gap: 10px;
  flex-direction: column;
  justify-content: center
  align-items: center;
  height: 200px;
  padding: 20px;
  border-radius: 10px;
  background-color: ${props => (props.isDragged ? '#eee' : 'white')};
  border: 2px dashed ${props => (props.isDragged ? '#111' : '#C5C4C4')};
  color: #444;
  cursor: pointer;
  transition: background 0.2s ease-in-out, border 0.2s ease-in-out;

  &:hover {
    background: #eee;
    border-color: #111;
  }

  &:hover .drop-title,
  &.drag-active .drop-title {
    color: #222;
  }
`;